import React from "react";

import ProDropDown from "../common/ProDropDown";
import ProFormFooter from "../common/ProFormFooter";
import ProInputText from "../common/ProInputText";
import ProTextArea from "../common/ProTextArea";
import ProAutoComplete from "../common/ProAutoComplete";

import { useFormik } from "formik";
import useWaitlist from "../../hooks/useWaitlist";
import useWaitlistForm from "../../hooks/useWaitlistForm";
import { useClientService } from "../../hooks/useClientService";

import { WaitlistClientModel } from "../../models/FormDataModel";
import WaitlistFormValidator from "./validator/WaitlistFormValidator";
import { ClientTypeOptions, WaitlistPriority } from "../../constants/ProConstants";
import _ from 'lodash'


const ProWaitlistForm = ({formModel, formAction, closeSideBar})=>{

    const {filteredClient, SearchClient} = useClientService();
    const {data:{allWaitlist, selectedWaitlist, allWaitlistStatuses, waitlistClients}, actions:{AddClientWaitlist, EditClientWaitlist}} = useWaitlist({refresh:false});
    const formik = useFormik({
        initialValues:  _.isEmpty(formModel)? {...WaitlistClientModel, waitlist:selectedWaitlist, waitlistStatus:_.gt(allWaitlistStatuses.length, 0)?allWaitlistStatuses[0]: {}}: formModel,        
        validate: (data) => {
            return WaitlistFormValidator(data, _.isEmpty(waitlistClients)?[] : waitlistClients[0].waitlistClients);                      
        },
        onSubmit: (data) => {           
           handleSubmit(data);
           formik.resetForm();
           closeSideBar();
        },
    });

    const {actions:{onChanged}} = useWaitlistForm({formik})

    const handleSubmit = async (data)=>{
        switch(formAction){
            case "ADD":               
                await AddClientWaitlist(data);         
                break;
            case "EDIT":
                await EditClientWaitlist(data);
                break;
            default:
                break;
        }
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <ProDropDown  
                headerText="Waitlist"          
                id="waitlist"
                value={formik.values.waitlist}
                style={{ width: "100%", marginBottom: "2px", height: "40px" }}
                onChange={onChanged}
                options={_.filter(allWaitlist, (w)=>_.isEqual(w.id, selectedWaitlist.id))} 
                optionLabel="name"
                placeholder="Waitlist"
                formik={formik}
                error = "waitlist"  
                disabled          
                required
            />  
            <ProDropDown   
                headerText="Client Information"        
                id="clientType"
                value={formik.values.clientType}
                style={{ width: "100%", marginBottom: "2px", height: "40px" }}
                onChange={onChanged}
                options={ClientTypeOptions} 
                optionLabel="name"
                placeholder="Client Status"
                formik={formik}
                error = "clientType"    
                disabled = {_.isEqual(formAction, "EDIT")}       
                required
            /> 
        {(_.get(formik.values.clientType, "code") === "CLIENT") && <ProAutoComplete
             id="client"                    
             labelText="Client" 
             field = "fullName"
             formik = {formik}
             minLength={3}
             multiple={false}
             value={formik.values.client}
             suggestions = {filteredClient}
             completeMethod = {SearchClient}                        
             onChange={onChanged}
             error = "client" 
             disabled = {_.isEqual(formAction, "EDIT")}            
             required
                 />          
        }
        {(_.get(formik.values.clientType, "code") === "PENDING_CLIENT") &&
        <>
             <ProInputText               
                id="pendingClientName"
                labelText="Pending Client Name"
                value={formik.values.pendingClientName}
                onChange={onChanged}
                formik={formik}
                error="pendingClientName"  
                disabled = {_.isEqual(formAction, "EDIT")}                 
                required                
                />  
           
            </> 
        }  
       {!_.isNull(formik.values.clientType) &&
         <>
         <ProDropDown   
                headerText="Client Prioritization Criteria"        
                id="priority"
                value={formik.values.priority}
                style={{ width: "100%", marginBottom: "2px", height: "40px" }}
                onChange={onChanged}
                options={WaitlistPriority} 
                optionLabel="name"
                placeholder="Priority"
                formik={formik}
                error = "priority"           
                required
            /> 
            
            <ProTextArea
                headerText="Notes"
                id="note"
                labelText="Notes"
                value={formik.values.note}
                onChange={onChanged}
                showCounter
                />     
        </> 
       }             
           <ProFormFooter onSave={() => console.log("Save")}  onCancel={closeSideBar} enableOnDirty={formik.dirty} />        
        </form>

    )

}

export default ProWaitlistForm;